(() => {
  function wrapTables(scope = document) {
    scope.querySelectorAll('.product-tabs__panel table').forEach((table) => {
      if (table.parentElement && table.parentElement.classList.contains('cap-table-wrap')) return;
      const wrap = document.createElement('div');
      wrap.className = 'cap-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }
  function markOverflow(scope = document) {
    scope.querySelectorAll('.product-tabs__nav').forEach((nav) => {
      nav.classList.toggle('is-overflowing', nav.scrollWidth > nav.clientWidth + 6);
    });
  }
  function init() {
    document.documentElement.classList.add('cap-final-ready');
    wrapTables(document);
    markOverflow(document);
  }
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', (event) => {wrapTables(event.target);markOverflow(event.target);});
  window.addEventListener('resize', () => markOverflow(document), { passive: true });
})();